import { Action, combineReducers, configureStore, ThunkAction } from "@reduxjs/toolkit";
import AppReducer from "components/app/App.slice";
import CustomFiterSlice from "components/app/CustomFilters.slice";
import ExportSlice from "components/common/Export/Export.slice";
import FiltersReducer from "components/common/Filters/Filters.slice";
import GlobalFiltersSlice from "components/common/Filters/GlobalFilters.slice";
import productsReducer from "components/common/plans/plans.slice";
import SnackbarSlice from "components/common/Snackbar/snackbar.slice";
import AbovePropertyReducer from "components/features/AboveProperty/AboveProperty.slice";
import AdminConsoleSlice from "components/features/AdminConsole/AdminConsole.slice";
import Comments from "components/features/Comments/Comments.slice";
import CopyToPlan from "components/features/CopyToPlan/CopyToPlan.slice";
import CorpDashboardSlice from "components/features/Corp/CorpUser.Slice";
import CustomPlanCreation from "components/features/CustomPlanCreation/CustomPlanCreation.slice";
import DashboardSlice from "components/features/dashboard/Dashboard.slice";
import HotelUserDashboardSlice from "components/features/dashboard/HotelUserDashboard.slice";
import PropertyOverviewSlice from "components/features/dashboard/PropertyOverview/PropertyOverview.slice";
import FeedbackReducer from "components/features/Feedback/Feedback.slice";
import GlobalSearchSlice from "components/features/GlobalSearch/GlobalSearch.slice";
import IndividualPropertyReducer from "components/features/IndividualProperty/IndividualProperty.slice";
import IndividualUserSlice from "components/features/IndividualUser/IndividualUser.slice";
import BookmarkedPlanReducer from "components/features/library/Bookmark/Bookmark.slice";
import individualActionSlice from "components/features/library/functionalArea/individualAction.slice";
import Library from "components/features/library/Library.slice";
import FunctionalAreaReducer from "components/features/library/libraryHall/Hall.slice";
import SuggestedPlansSlice from "components/features/library/SuggestedPlans/SuggestedPlans.slice";
import ManageSuggestionsSlice from "components/features/ManageSuggestions/ManageSuggestions.slice";
import MyPlanDetailsReducer from "components/features/MyPlanDetails/MyPlanDetails.slice";
import myplansReducer from "components/features/MyPlans/myplans.slice";
import NotificationsSlice from "components/features/Notifications/Notifications.slice";
import OnboardingSlice from "components/features/Onboarding/Onboarding.slice";
import PlanAssignment from "components/features/PlanAssignment/PlanAssignment.slice";
import PlanDetailsReducer from "components/features/planDetails/PlanDetail.slice";
import PrivacyAndDisclaimer from "components/features/PrivacyAndDisclaimer/PrivacyAndDisclaimer.slice";
import ProgressSlice from "components/features/Progress/Progress.slice";
import ReleaseHighlights from "components/features/ReleaseHighlight/ReleaseHighlights.slice";
import SMEReducer from "components/features/SME/sme.slice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import FormSlice from "./forms.slice";
import SortingSlice from "./sorting.slice";

export const rootReducer = combineReducers({
  aboveProperty: AbovePropertyReducer,
  adminConsole: AdminConsoleSlice,
  app: AppReducer,
  bookmarkedPlans: BookmarkedPlanReducer,
  Comments,
  CopyToPlan,
  CustomPlanCreation,
  CorpDashboard: CorpDashboardSlice,
  Dashboard: DashboardSlice,
  Export: ExportSlice,
  feedback: FeedbackReducer,
  filters: FiltersReducer,
  formDetails: FormSlice,
  functionalAreas: FunctionalAreaReducer,
  globalSearch: GlobalSearchSlice,
  globalFilters: GlobalFiltersSlice,
  hotelUserDashboardSlice: HotelUserDashboardSlice,
  individualAction: individualActionSlice,
  individualProperty: IndividualPropertyReducer,
  individualUser: IndividualUserSlice,
  Library,
  manageSuggestions: ManageSuggestionsSlice,
  myPlanDetails: MyPlanDetailsReducer,
  myplans: myplansReducer,
  Notifications: NotificationsSlice,
  Onboarding: OnboardingSlice,
  PlanAssignment,
  planDetails: PlanDetailsReducer,
  plans: productsReducer,
  PrivacyAndDisclaimer: PrivacyAndDisclaimer,
  progress: ProgressSlice,
  PropertyOverviewSlice: PropertyOverviewSlice,
  ReleaseHighlights,
  sme: SMEReducer,
  snackbarDetails: SnackbarSlice,
  sortingDetails: SortingSlice,
  suggestedPlans: SuggestedPlansSlice,
  CustomFiterSlice: CustomFiterSlice
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["app", "functionalAreas"]
};

export type NonPersistedRootState = ReturnType<typeof rootReducer>;

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
